import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import TxTrackerDidNotRun from 'components/common/icons/treatmentTracker/TxTrackerDidNotRun'
import DazzedHeading24 from 'components/common/text/DazzedHeading24'
import DazzedParagraph16 from 'components/common/text/DazzedParagraph16'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  pendingStateContainer: {
    height: '100%'
  },
  title: {
    fontWeight: 'bold'
  }
}))

const NoTxTrackerData = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Grid
      container
      className={classes.pendingStateContainer}
      alignItems="center"
      justifyContent="center"
      direction="column"
      spacing={2}
    >
      <Grid item>
        <TxTrackerDidNotRun />
      </Grid>
      <Grid item>
        <DazzedHeading24 className={classes.title}>
          {t('dialogs.treatmentTracker.noTxTrackerDataState.title')}
        </DazzedHeading24>
      </Grid>
      <Grid item>
        <DazzedParagraph16 strong>{t('dialogs.treatmentTracker.noTxTrackerDataState.text')}</DazzedParagraph16>
      </Grid>
    </Grid>
  )
}

export default NoTxTrackerData
